import {Component, Input} from '@angular/core';
import {PlayerProfileStatistics} from '../../../../model/player-profile-statistics';
import {DecimalPipe} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {Card} from 'primeng/card';
import {Tooltip} from 'primeng/tooltip';

@Component({
  selector: 'app-player-profile-statistics-view',
  standalone: true,
  imports: [
    DecimalPipe,
    TranslatePipe,
    Card,
    Tooltip
  ],
  templateUrl: './player-profile-statistics-view.component.html',
  styleUrl: './player-profile-statistics-view.component.scss'
})
export class PlayerProfileStatisticsViewComponent
{
  @Input() playerProfileStatistics: PlayerProfileStatistics;
}
